export default "__VITE_ASSET__7ebb0f19__"